import types from '@/actions/outsideTypes';
import { required } from '@/utils/validate';
import { $saveOutside, $getOutside, $removeOutside } from '@/_api_/outsideAPI';
import { _loading, _loaded } from '@/actions/commonAction';
import { _getGohomeData } from '@/actions/mainAction';
import { toast } from 'react-toastify';

/* Actions */

export const _getOutside = () => async (dispatch, getState) => {
  if (required(getState().main.empNo)) {
    toast.error("사번을 입력하세요.")
    return;
  }
  dispatch(_loading())
  const response = await $getOutside(getState().main.empNo, getState().main.date);
  dispatch({
    type: types.SET_OUTSIDE_DATA,
    data: response.data
  })
  dispatch(_loaded());
}

export const _saveOutside = () => async (dispatch, getState) => {
  if (required(getState().main.empNo)) {
    toast.error("사번을 입력하세요.")
    return;
  }
  dispatch(_loading())
  const state = getState().outside;
  await $saveOutside({
    empNo: getState().main.empNo,
    startHour: parseInt(state.startHour, 10),
    startMinute: parseInt(state.startMinute, 10),
    endHour: parseInt(state.endHour, 10),
    endMinute: parseInt(state.endMinute, 10),
    startDate: state.startDate,
    endDate: state.endDate,
    desc: state.desc
  });
  dispatch({
    type: types.SAVE_OUTSIDE_DATA
  });
  dispatch(_getOutside());
}

export const _updateOutsideInputValue = (key, value) => (dispatch) => {
  dispatch({
    type: types.UPDATE_INPUT_VALUE,
    key,
    value
  })
}

export const _removeOutside = (startTime) => async (dispatch, getState) => {
  dispatch(_loading())
  await $removeOutside(getState().main.empNo, startTime);
  dispatch(_getOutside());
}

export const _openOutsideModal = () => (dispatch) => {
  dispatch({
    type: types.OPEN_MODAL
  })
  dispatch(_getOutside());
}

export const _closeOutsideModal = () => (dispatch) => {
  dispatch({
    type: types.CLOSE_MODAL
  })
  dispatch(_getGohomeData());
}


// WEBPACK FOOTER //
// ./src/actions/outsideAction.js